import { observable, action } from "mobx";
import { IInstance } from "../../../interfaces/IInstance";
import { Helper } from "../../../Helper";

import { IComponentInstances } from "../../../interfaces/IComponentInstances";
import { IAppPage } from "../../../interfaces/IAppPage";
import { TargetingService } from "../../../services/TargetingService";
import { IHttpStatus } from "../../../interfaces/IHttpStatus";
import { ITargetingApplications } from "../../../interfaces/ITargetingApplications";
import { IApplication, IDefaultValues, Instance } from "../../../interfaces/IApplication";

export class AppAdminStore {
  @observable public token: string;
  @observable public environment: "Development" | "Test" | "Production";
  @observable public tenant: string;
  @observable public instance: IInstance = {
    settings: {
      design: {
        icon: undefined,
        logo: undefined,
        navigationBarColor: "#333333",
        navigationBarContentColor: "#ffffff",
        tabBarColor: "#cccccc",
        tabBarContentColor: "#666666",
        tabBarHighlightColor: "#23879b",
        menuColor: "#333333",
        menuContentColor: "#ffffff",
        menuHighlightColor: "#23879b",
        contentAreaColor: "#eeeeee",
        contentAreaContentColor: "#333333",
        contentAreaHighlightColor: "#23879b",
        menuStyle: "TabBar"
      },
      menu: [],
      push: {
        instances: []
      }
    }
  };

  @observable public blockReload: boolean = false;

  @observable public isSaving: boolean;
  @observable public loading: boolean;

  @observable public editDesign: boolean = false;
  @observable public editPage: boolean = false;
  @observable public sortPages: boolean = false;
  @observable public previewSplashScreen: string;

  @observable public hasChanged: string;
  @observable public instanceOriginal: IInstance;

  @action public createNewPage(): void {
    this.selectedPageIndex = this.instance.settings.menu.length;
    this.instance.settings.menu[this.selectedPageIndex] = {
      icon: "HeartFill",
      components: []
    };
  }

  @observable public loadingInstances: boolean;
  @observable public availableInstancesForComponent: any[];
  @observable public contentOrgazinerInstances: any[];
  @observable public pageIndexToDelete: number;
  @observable public componentIndexToDelete: number;
  @observable public showCancelEditPopup: boolean;
  @observable public componentInstances: IComponentInstances = { Messages: [], Event: [] };

  @observable public pages: JSX.Element[][];
  @observable public selectedPageIndex: number = 0;
  @observable public selectedComponentIndex: number;

  @action public checkForChanges(): void {
    if (JSON.stringify(this.instance) !== JSON.stringify(this.instanceOriginal)) {
      this.hasChanged = Helper.getRandomStringKey();
    } else {
      this.hasChanged = undefined;
    }
  }

  @action public deleteComnponent(): Promise<void> {
    return new Promise<void>((resolve: () => void): void => {
      this.instance.settings.menu[this.selectedPageIndex].components.splice(this.componentIndexToDelete, 1);
      resolve();
    });
  }

  @action public deletePage(): Promise<void> {
    return new Promise<void>((resolve: () => void): void => {
      let selectedIndex: number;
      this.instance.settings.menu.forEach((page: IAppPage, index) => {
        if (JSON.stringify(page) === JSON.stringify(this.instance.settings.menu[this.pageIndexToDelete])) {
          selectedIndex = index;
        }
      });
      this.instance.settings.menu.splice(selectedIndex, 1);
      resolve();
    });
  }

  @observable public editComponent: boolean;

  @action public createNewItem(index?: number): void {
    this.selectedComponentIndex = index !== undefined ? index : this.instance.settings.menu[this.selectedPageIndex].components.length > 0 ? this.instance.settings.menu[this.selectedPageIndex].components.length : 0;
    if (this.instance.settings.menu[this.selectedPageIndex].components.length === 0) {
      this.instance.settings.menu[this.selectedPageIndex].components.push({});
      // this.instance.settings.menu[this.selectedPageIndex].components.push({
      //   type: "EmbeddedPage"
      // });
    } else {
      // const component = {
      //   type: "IntraActive-Messages",
      //   display: "Card view",
      //   numberOfCards: 4,
      //   showDropShadow: true,
      //   showImage: true,
      //   showCardTitle: true,
      //   showTeaser: true,
      //   showContact: true,
      //   showStartDate: true,
      //   showLikes: true,
      //   showComments: true,
      //   showViews: true,
      //   showCategories: true,
      // };
      if (this.selectedComponentIndex === this.instance.settings.menu[this.selectedPageIndex].components.length) {
        this.instance.settings.menu[this.selectedPageIndex].components.push({});
      } else {
        this.instance.settings.menu[this.selectedPageIndex].components.splice(this.selectedComponentIndex, 0, {});
      }
    }
    setTimeout(() => {
      this.editComponent = true;
    }, 500);
    this.checkForChanges();
  }

  @action public reloadPage(): void {
    if (!this.blockReload && !this.editDesign) {
      if (this.selectedPageIndex === undefined) {
        this.selectedPageIndex = 0;
      }
      const tempIndex = this.selectedPageIndex;
      if (this.pages?.length > 0) {
        this.pages[this.selectedPageIndex] = undefined;
      }
      this.selectedPageIndex = undefined;
      setTimeout(() => {
        this.selectedPageIndex = tempIndex;
      }, 0);
    }
  }

  // Get Targeting Application information

  @action public async getTargetingApplication(): Promise<void> {
    return await TargetingService.getApplication(this.environment, this.tenant, this.token, 'App', true).then((response: { httpStatus: IHttpStatus, value?: ITargetingApplications[] }) => {
      this.applicationSettings = response.value[0];
      let application: IApplication;
      if (response.value && response.value.length > 0) {
        const appData = JSON.parse(response.value[0].defaultValues);
        let defaultValues: IDefaultValues;
        if (!appData || Array.isArray(appData)) {
          const list: any[] = [];
          defaultValues = {
            isEnable: false,
            type: 'profileData',
            values: list,
            allValues: false,
          };
          application = {
            id: undefined,
            title: response.value[0].title,
            name: response.value[0].title,
            instances: [],
            default: defaultValues,
          };
        } else {
          application = appData;
          if (response.value && response.value[0]) {
            application.default.type = response.value[0].applicationSettings?.toLocaleLowerCase() === 'profile data' ? 'profileData' : 'userGroups';
          }
        }

        if (application) {
          if (application.default && typeof application.default.isEnable === 'string') {
            application.default.isEnable = /true/i.test(application.default.isEnable);
          }

          if (application.instances && application.instances.length > 0) {
            application.instances.forEach((i: Instance) => {
              if (i && typeof i.isEnable === 'string') {
                const isEnabled: string = i.isEnable;
                i.isEnable = /true/i.test(isEnabled);
              }
            });
          }
        }

        // this.applicationSettings.application = application;
      }
    },
    );
  }

  @observable public applicationSettings: any;

}